var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"position":"relative"},attrs:{"id":"full-store-preview"}},[_c('Client_App',{attrs:{"admin_imported":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }